const JST_TIME_ZONE = 'Asia/Tokyo';

/**
 * ISO 8601 文字列を JST 表示へ正規化する。
 */
export const formatJstDateTime = (value?: string | null): string => {
  if (!value) {
    return '-';
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return parsed.toLocaleString('ja-JP', {
    timeZone: JST_TIME_ZONE,
  });
};
